import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";

import { Table, Empty, Col, Row } from "antd";
import { BarsOutlined } from "@ant-design/icons";
import { auth } from "firebase";

const ErpFirmReportDetail = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });

  useEffect(
    () => getTableData(),
    [tableDataQueryOptions, props.firmCode, props.currency]
  );

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });
    const { skip, take, filter } = tableDataQueryOptions;

    let conditions = [];
    let query = "";

    if (props.firmCode) {
      conditions.push(`firmCode eq '${props.firmCode}'`);
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = conditions.join(" and ");
    }

    RequestHandler.get(
      `/ErpReport/GetLogoFirmTransaction/${props.firmCode}`
    ).then((response) => {
      setTableData({
        data: response,
        total: response,
        loading: false,
      });
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { ...prevState, skip: 0, current: 1, filter: query };
    });
  };

  let columns = [
    {
      title: "Vade Tarihi",
      dataIndex: "FİŞ TARİHİ",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "İşlem Tipi",
      render: (data,row,index) => "-"
    },
    {
      title: "Açıklama",
      dataIndex: "HAREKET AÇIKLAMASI",
      render: (data,row,index) => {
        if(data) {
          return data;
        }
        else {
          return "-";
        }
      }
    },
    {
      title: "Evrak No",
      dataIndex: "FİŞ NO",
    },
    {
      title: "Fatura No",
      render: (data,row,index) => "-"
    },
    {
      title: "Borç",
      dataIndex: "TUTAR",
      render: (data,row,index) => {
        if(parseFloat(data) < 0) {
          return data;
        }
        else {
          return "-";
        }
      }
    },
    {
      title: "Alacak",
      dataIndex: "TUTAR",
      render: (data,row,index) => {
        if(parseFloat(data) > 0) {
          return data;
        }
        else {
          return "-";
        }
      }
    },
  ];


    columns = columns.concat([
      {
        title: "Bakiye",
        render: (data,row,index) => "-"
      },
      {
        title: "Döviz Kuru",
        dataIndex: "DÖVİZ TÜRÜ",
      },
    ]);
  
  return (
    <>
      <Row>
        <Col xs={15} lg={20}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> CARİ DETAY
          </p>
        </Col>
        <Col flex="auto">
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <b>Bakiye:</b> {props.balance}
          </p>
        </Col>
      </Row>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default ErpFirmReportDetail;
